import { Constants } from "./constants";

export class Roles_Permissions_Constants {
  static get DASHBOARD_ROLES() {
    return {
      VOR: "VOR",
      UPLOADER: "UPLOADER",
      REVIEWER: "REVIEWER",
      APPROVER: "APPROVER",
      REGISTRAR: "REGISTRAR",
    };
  }

  static get ORG_ADMIN_ROLES() {
    return {
      UPLOADER: "ORG_ADMIN_UPLOADER",
      REVIEWER: "ORG_ADMIN_REVIEWER",
      APPROVER: "ORG_ADMIN_APPROVER",
    };
  }

  static get BRS_OPS_ROLES() {
    return {
      UPLOADER: "BRS_OPS_UPLOADER",
      REVIEWER: "BRS_OPS_REVIEWER",
      APPROVER: "BRS_OPS_APPROVER",
    };
  }

  static get SUPER_ADMIN_ROLES() {
    return {
      UPLOADER: "SUPER_ADMIN_UPLOADER",
      REVIEWER: "SUPER_ADMIN_REVIEWER",
      APPROVER: "SUPER_ADMIN_APPROVER",
    };
  }

  static get BILLING_ROLES() {
    return {
      UPLOADER: "BILLING_UPLOADER",
      REVIEWER: "BILLING_REVIEWER",
      APPROVER: "BILLING_APPROVER",
    };
  }

  static get DOCUMENT_PERMISSIONS() {
    return {
      STATUTORY_RECORDS: "STATUTORY_RECORDS",
      DIRECTOR_RESOLUTIONS_AND_CONSENTS: "DIRECTOR_RESOLUTIONS_AND_CONSENTS",
      SHAREHOLDER_RESOLUTIONS_AND_CONSENTS:
        "SHAREHOLDER_RESOLUTIONS_AND_CONSENTS",
      REGISTER_OF_DIRECTORS_AND_SECRETARIES:
        "REGISTER_OF_DIRECTORS_AND_SECRETARIES",
      REGISTER_OF_DIRECTORS_AND_SECRETARIES_RESIDENCES:
        "REGISTER_OF_DIRECTORS_AND_SECRETARIES_RESIDENCES",
      REGISTER_OF_MEMBERS: "REGISTER_OF_MEMBERS",
      REGISTER_OF_APPLICATIONS_AND_ALLOTMENTS:
        "REGISTER_OF_APPLICATIONS_AND_ALLOTMENTS",
      REGISTER_OF_TRANSFERS: "REGISTER_OF_TRANSFERS",
      REGISTER_OF_CHARGES_MORTGAGES: "REGISTER_OF_CHARGES_MORTGAGES",
      REGISTER_OF_DEBENTURES: "REGISTER_OF_DEBENTURES",
      REGISTER_OF_BENEFICIAL_OWNERS: "REGISTER_OF_BENEFICIAL_OWNERS",
      SHARE_CERTIFICATES: "SHARE_CERTIFICATES",
      AGREEMENTS_AND_CONTRACTS: "AGREEMENTS_AND_CONTRACTS",
      POLICIES: "POLICIES",
    };
  }
  static get DASHBOARD_PERMISSIONS() {
    return {
      VIEW_OWN_DATA: "VIEW_OWN_DATA",
      EDIT_OWN_DATA: "EDIT_OWN_DATA",
      VIEW_PUBLIC_DATA: "VIEW_PUBLIC_DATA",
      VIEW_RESTRICTED_DATA: "VIEW_RESTRICTED_DATA",
      EDIT_OTHER_DATA: "EDIT_OTHER_DATA",
      REVIEW_TRANSACTIONS: "REVIEW_TRANSACTIONS",
      APPROVE_TRANSACTIONS: "APPROVE_TRANSACTIONS",
      MANAGE_USERS: "MANAGE_USERS",
      // MINUTE_BOOK: "MINUTE_BOOK",
      SHOW_REQUEST_BUTTON: "SHOW_REQUEST_BUTTON",
      // Documents
      ...this.DOCUMENT_PERMISSIONS,
    };
  }

  static get DASHBOARD_PERMISSIONS_AGAINST_DESIGNATIONS() {
    return {
      [Constants.APPLICANT_CAPACITIES.DIRECTOR]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.UPLOADER,
        [this.DASHBOARD_ROLES.REVIEWER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.APPROVER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.REGISTRAR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.REGISTRAR,
      },
      [Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.UPLOADER,
        [this.DASHBOARD_ROLES.REVIEWER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.APPROVER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.REGISTRAR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.REGISTRAR,
      },
      [Constants.APPLICANT_CAPACITIES.SHAREHOLDER]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Not a default role
        [this.DASHBOARD_ROLES.REVIEWER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.APPROVER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.REGISTRAR]: [],
      },
      [Constants.APPLICANT_CAPACITIES.JOINT_SHAREHOLDER]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Not a default role
        [this.DASHBOARD_ROLES.REVIEWER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.APPROVER]: [
          ...this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
        ],
        [this.DASHBOARD_ROLES.REGISTRAR]: [],
      },
      [Constants.APPLICANT_CAPACITIES.AUTHORIZED_PERSON]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]: [],
        [this.DASHBOARD_ROLES.REVIEWER]: [],
        [this.DASHBOARD_ROLES.APPROVER]: [],
        [this.DASHBOARD_ROLES.REGISTRAR]: [],
      },
      [Constants.APPLICANT_CAPACITIES.COMPANY_SECRETARY]: {
        [this.DASHBOARD_ROLES.VOR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.VOR,
        [this.DASHBOARD_ROLES.UPLOADER]: [],
        [this.DASHBOARD_ROLES.REVIEWER]: [], // Doesn't have this role
        [this.DASHBOARD_ROLES.APPROVER]: [], // Doesn't have this role
        [this.DASHBOARD_ROLES.REGISTRAR]:
          this.DASHBOARD_PERMISSIONS_AGAINST_ROLES.REGISTRAR,
      },
    };
  }
  static createRequestPermissions(role, Designation) {
    const permissionsForDesignation =
      this.REQUEST_DASHBOARD_PERMISSIONS_AGAINST_DESIGNATIONS[Designation];
    const defaultPermissionsForDesignation =
      this.DASHBOARD_PERMISSIONS_AGAINST_DESIGNATIONS[Designation];
    const permissions = defaultPermissionsForDesignation[role].map(
      (permission) => {
        return {
          name: permission,
          label: this.getPermissionLabel(permission),
          isDefault: true,
        };
      }
    );
    permissionsForDesignation[role].forEach((permission) => {
      permissions.push({
        name: permission,
        label: this.getPermissionLabel(permission),
        isDefault: false,
      });
    });
    return permissions;
  }

  static getPermissionLabel(permission) {
    const labels = {
      VIEW_OWN_DATA: "View Own Data",
      EDIT_OWN_DATA: "Edit Own Data",
      VIEW_PUBLIC_DATA: "View Public Data",
      VIEW_RESTRICTED_DATA: "View Restricted Data",
      EDIT_OTHER_DATA: "Edit Other Data",
      REVIEW_TRANSACTIONS: "Review Transactions",
      APPROVE_TRANSACTIONS: "Approve Transactions",
      MANAGE_USERS: "Manage users",
      STATUTORY_RECORDS: "Statutory Records",
      DIRECTOR_RESOLUTIONS_AND_CONSENTS: "Director Resolutions and Consents",
      SHAREHOLDER_RESOLUTIONS_AND_CONSENTS:
        "Shareholder Resolutions and Consents",
      REGISTER_OF_DIRECTORS_AND_SECRETARIES:
        "Register of Directors and Secretaries",
      REGISTER_OF_DIRECTORS_AND_SECRETARIES_RESIDENCES:
        "Register of Directors and Secretaries' Residences",
      REGISTER_OF_MEMBERS: "Register of members",
      REGISTER_OF_APPLICATIONS_AND_ALLOTMENTS:
        "Register of Applications and Allotments",
      REGISTER_OF_TRANSFERS: "Register of Transfers",
      REGISTER_OF_CHARGES_MORTGAGES: "Register of Charges/Mortgages",
      REGISTER_OF_DEBENTURES: "Register of Debentures",
      REGISTER_OF_BENEFICIAL_OWNERS: "Register of Beneficial Owners",
      SHARE_CERTIFICATES: "Share Certificates",
      AGREEMENTS_AND_CONTRACTS: "Agreements & Contracts",
      POLICIES: "Policies",
    };
    return labels[permission];
  }
  static get REQUEST_DASHBOARD_PERMISSIONS_AGAINST_DESIGNATIONS() {
    return {
      [Constants.APPLICANT_CAPACITIES.DIRECTOR]: {
        [this.DASHBOARD_ROLES.VOR]: [], // VOR can't request anything
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [
          this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
          this.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
          ...Object.values(this.DOCUMENT_PERMISSIONS),
        ],
        [this.DASHBOARD_ROLES.APPROVER]: [
          this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
          this.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
          ...Object.values(this.DOCUMENT_PERMISSIONS),
          this.DASHBOARD_PERMISSIONS.MANAGE_USERS,
        ],
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
      [Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER]: {
        // Union of Director & Shareholder
        [this.DASHBOARD_ROLES.VOR]: [], // VOR can't request anything
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [
          this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
          this.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
          this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
          ...Object.values(this.DOCUMENT_PERMISSIONS),
        ], // Union of Director & Shareholder
        [this.DASHBOARD_ROLES.APPROVER]: [
          this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
          this.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
          this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
          ...Object.values(this.DOCUMENT_PERMISSIONS),
          this.DASHBOARD_PERMISSIONS.MANAGE_USERS,
        ], // Union of Director & Shareholder
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
      [Constants.APPLICANT_CAPACITIES.SHAREHOLDER]: {
        [this.DASHBOARD_ROLES.VOR]: [], // VOR can't request anything
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [], // Shareholder as reviewer can't request anything
        [this.DASHBOARD_ROLES.APPROVER]: [], // Shareholder as approver can't request anything
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
      [Constants.APPLICANT_CAPACITIES.JOINT_SHAREHOLDER]: {
        [this.DASHBOARD_ROLES.VOR]: [], // VOR can't request anything
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [], // Shareholder as reviewer can't request anything
        [this.DASHBOARD_ROLES.APPROVER]: [], // Shareholder as approver can't request anything
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
      [Constants.APPLICANT_CAPACITIES.AUTHORIZED_PERSON]: {
        [this.DASHBOARD_ROLES.VOR]: [], // VOR can't request anything
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [], // Shareholder as reviewer can't request anything
        [this.DASHBOARD_ROLES.APPROVER]: [], // Shareholder as approver can't request anything
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
      [Constants.APPLICANT_CAPACITIES.COMPANY_SECRETARY]: {
        [this.DASHBOARD_ROLES.VOR]: [
          this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
        ],
        [this.DASHBOARD_ROLES.UPLOADER]: [], // Uploader can't request anything
        [this.DASHBOARD_ROLES.REVIEWER]: [], // Reviewer can't request anything
        [this.DASHBOARD_ROLES.APPROVER]: [], // Approver can't request anything
        [this.DASHBOARD_ROLES.REGISTRAR]: [], // Registrar can't request anything as he already has everything
      },
    };
  }

  static get DASHBOARD_PERMISSIONS_AGAINST_ROLES() {
    return {
      VOR: [
        this.DASHBOARD_PERMISSIONS.VIEW_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.EDIT_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.VIEW_PUBLIC_DATA,
      ],
      UPLOADER: [
        this.DASHBOARD_PERMISSIONS.VIEW_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.EDIT_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.VIEW_PUBLIC_DATA,
        this.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
        this.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
      ],
      REVIEWER: [
        this.DASHBOARD_PERMISSIONS.VIEW_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.EDIT_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.VIEW_PUBLIC_DATA,
        this.DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
      ],
      APPROVER: [
        this.DASHBOARD_PERMISSIONS.VIEW_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.EDIT_OWN_DATA,
        this.DASHBOARD_PERMISSIONS.VIEW_PUBLIC_DATA,
        this.DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
      ],
      REGISTRAR: Object.values(this.DASHBOARD_PERMISSIONS),
    };
  }

  static get EMPLOYEE_DATA_PERMISSIONS() {
    return {
      VIEW_RESTRICTED_DATA: "VIEW_RESTRICTED_DATA",
      EDIT_OTHER_DATA: "EDIT_OTHER_DATA",
      MANAGE_USERS: "MANAGE_USERS",
    };
  }

  static get EMPLOYEE_DOCUMENT_PERMISSIONS() {
    return {
      REGISTRARS_OF_MEMBERS: "REGISTRARS_OF_MEMBERS",
      REGISTRARS_OF_DIRECTORS: "REGISTRARS_OF_DIRECTORS",
      MINUTE_BOOK_DIRECTORS: "MINUTE_BOOK_DIRECTORS",
    };
  }
}
